<template>
    <div id="ssy">
        <ul>
            <li :class="{active:active == 52}" @click="active = 52">
                <p class="a">充多少送多少</p>
                <h1>11<span>元</span></h1>
                <p class="b">充值11元送11元 <br>2200个书币+书豆</p>
                <div class="active"><i class="el-icon-check"></i></div>
            </li>
            <li :class="{active:active == 53}" @click="active = 53">
                <p class="a">充的多送的多</p>
                <h1>51<span>元</span></h1>
                <p class="b">充值51元送61元 <br>11200个书币+书豆</p>
                <div class="active"><i class="el-icon-check"></i></div>

            </li>
        </ul>
        <div class="c" :class="{active:active == 54}" @click="active = 54">
            <h1>111<span>元</span></h1>
            <p class="b">充值111元送189元30000个书币+书豆</p>
            <div class="active"><i class="el-icon-check"></i></div>

        </div>
        <div class="btn" @click="doRecharge"></div>
    </div>
</template>

<script>
    export default {
        name: "Ssy",
        data(){
            return {
                active : 52
            }
        },
        methods : {
            doRecharge(){
                if(this.active < 52){
                    alert("请选择充值选项！");
                    return;
                }
                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    return ;
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : 18,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        },
    }
</script>

<style lang="less">
    #ssy{width: 100%;height: 100%;min-height:1500px;background: url("http://static.yuread.cn/upload/activity/11bg.jpg");background-size: 100% 100%;padding-top: 600px;
        ul{
            width: 670px;display: flex;justify-content: space-between;margin:0 auto;

            li{height: 320px;width: 315px;background-image: url("http://static.yuread.cn/upload/activity/11b.png");background-size: 100% 100%;position: relative;
                .a{text-align: center;font-size: 30px;color: #f91311;line-height: 50px;}
                h1{text-align: center;color: #f91311;font-size: 96px;font-style: oblique;padding-top: 20px;
                    span{font-size: 30px;}
                }
                .b{text-align: center;font-size: 26px;color: #f91311;padding-top: 26px;}
                .active{position:absolute;top:10px;right:10px;width: 40px;height:40px;border-radius: 50%;border:2px solid #f91311;text-align: center;display: none;
                    i{font-size: 30px;position: relative;top:-4px;font-weight: bold;color: #f91311;}
                }

            }
            .active{
                .active{display: block;}
            }
        }
        .c{width: 670px;height:319px;margin: 40px auto;background-image: url("http://static.yuread.cn/upload/activity/11a.png");background-size: 100% 100%;position: relative;
            h1{text-align: center;color: #f91311;font-size: 96px;font-style: oblique;padding-top: 70px;
                span{font-size: 30px;}
            }
            .b{text-align: center;font-size: 37px;color: #f91311;padding-top: 37px;}
            .active{position:absolute;top:10px;right:10px;width: 40px;height:40px;border-radius: 50%;border:2px solid #f91311;text-align: center;display: none;
                i{font-size: 30px;position: relative;top:-4px;font-weight: bold;color: #f91311;}
            }
        }
        .active{
            .active{display: block;}
        }

        .btn{width: 596px;height: 100px;background-image: url("http://static.yuread.cn/upload/activity/11c.png");background-size: 100% 100%;margin:0 auto;}
    }
</style>
